<template>
	<div>
		<div class="pay_ok">
			<div class="ok_icon">
				<van-icon
					:name="payType == 'payok' ? 'passed' : 'close'"
					:color="payType == 'payok' ? '#07C160' : 'red'"
					size="8rem"
				/>
			</div>
			<div class="ok_text">
				{{ payType == 'payok' ? '支付成功' : '支付失败' }}
			</div>
			<div class="ok_button">
				<van-button
					type="danger"
					style="width: 10rem"
					@click="gotoCourse()"
					>回到APP</van-button
				>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			payType: '',
		}
	},
	created() {
		this.payType = this.$route.query.payType
	},
	methods: {
		gotoCourse() {
			console.log('111')
			window.location.href = 'wzcjapp://open'
		},
	},
}
</script>
<style>
.pay_ok {
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.ok_text {
	margin-top: 3rem;
}
.ok_button {
	margin-top: 3rem;
}
</style>
